import { z } from 'zod';

export type weatherSymbol = z.infer<typeof weatherSymbolSchema>;
export const weatherSymbolSchema = z.union([
  z.literal('clearsky_day'),
  z.literal('clearsky_night'),
  z.literal('clearsky_polartwilight'),
  z.literal('cloudy'),
  z.literal('fair_day'),
  z.literal('fair_night'),
  z.literal('fair_polartwilight'),
  z.literal('fog'),
  z.literal('heavyrain'),
  z.literal('heavyrainandthunder'),
  z.literal('heavyrainshowers_day'),
  z.literal('heavyrainshowers_night'),
  z.literal('heavyrainshowers_polartwilight'),
  z.literal('heavyrainshowersandthunder_day'),
  z.literal('heavyrainshowersandthunder_night'),
  z.literal('heavyrainshowersandthunder_polartwilight'),
  z.literal('heavysleet'),
  z.literal('heavysleetandthunder'),
  z.literal('heavysleetshowers_day'),
  z.literal('heavysleetshowers_night'),
  z.literal('heavysleetshowers_polartwilight'),
  z.literal('heavysleetshowersandthunder_day'),
  z.literal('heavysleetshowersandthunder_night'),
  z.literal('heavysleetshowersandthunder_polartwilight'),
  z.literal('heavysnow'),
  z.literal('heavysnowandthunder'),
  z.literal('heavysnowshowers_day'),
  z.literal('heavysnowshowers_night'),
  z.literal('heavysnowshowers_polartwilight'),
  z.literal('heavysnowshowersandthunder_day'),
  z.literal('heavysnowshowersandthunder_night'),
  z.literal('heavysnowshowersandthunder_polartwilight'),
  z.literal('lightrain'),
  z.literal('lightrainandthunder'),
  z.literal('lightrainshowers_day'),
  z.literal('lightrainshowers_night'),
  z.literal('lightrainshowers_polartwilight'),
  z.literal('lightrainshowersandthunder_day'),
  z.literal('lightrainshowersandthunder_night'),
  z.literal('lightrainshowersandthunder_polartwilight'),
  z.literal('lightsleet'),
  z.literal('lightsleetandthunder'),
  z.literal('lightsleetshowers_day'),
  z.literal('lightsleetshowers_night'),
  z.literal('lightsleetshowers_polartwilight'),
  z.literal('lightsnow'),
  z.literal('lightsnowandthunder'),
  z.literal('lightsnowshowers_day'),
  z.literal('lightsnowshowers_night'),
  z.literal('lightsnowshowers_polartwilight'),
  z.literal('lightssleetshowersandthunder_day'),
  z.literal('lightssleetshowersandthunder_night'),
  z.literal('lightssleetshowersandthunder_polartwilight'),
  z.literal('lightssnowshowersandthunder_day'),
  z.literal('lightssnowshowersandthunder_night'),
  z.literal('lightssnowshowersandthunder_polartwilight'),
  z.literal('partlycloudy_day'),
  z.literal('partlycloudy_night'),
  z.literal('partlycloudy_polartwilight'),
  z.literal('rain'),
  z.literal('rainandthunder'),
  z.literal('rainshowers_day'),
  z.literal('rainshowers_night'),
  z.literal('rainshowers_polartwilight'),
  z.literal('rainshowersandthunder_day'),
  z.literal('rainshowersandthunder_night'),
  z.literal('rainshowersandthunder_polartwilight'),
  z.literal('sleet'),
  z.literal('sleetandthunder'),
  z.literal('sleetshowers_day'),
  z.literal('sleetshowers_night'),
  z.literal('sleetshowers_polartwilight'),
  z.literal('sleetshowersandthunder_day'),
  z.literal('sleetshowersandthunder_night'),
  z.literal('sleetshowersandthunder_polartwilight'),
  z.literal('snow'),
  z.literal('snowandthunder'),
  z.literal('snowshowers_day'),
  z.literal('snowshowers_night'),
  z.literal('snowshowers_polartwilight'),
  z.literal('snowshowersandthunder_day'),
  z.literal('snowshowersandthunder_night'),
  z.literal('snowshowersandthunder_polartwilight'),
]);

export type WeatherData = z.infer<typeof weatherDataSchema>;
export const weatherDataSchema = z.object({
  weatherDataId: z.number(),
  projectId: z.number(),
  forecastTime: z.string(),
  weatherSymbol: weatherSymbolSchema.nullable(),
  temperature: z.number().nullable(),
  precipitation: z.number().nullable(),
  relativeHumidity: z.number().nullable().optional(),
  windDirection: z.number().nullable().optional(),
  dewPoint: z.number().nullable().optional(),
  cloudCover: z.number().nullable().optional(),
  cloudCoverLow: z.number().nullable().optional(),
  cloudCoverMedium: z.number().nullable().optional(),
  cloudCoverHigh: z.number().nullable().optional(),
  fogCover: z.number().nullable().optional(),
});

export type FormattedWeatherData = {
  xTick: number;
  temperature: number | null;
  precipitation: number | null;
  weatherSymbol: string | null;
  relativeHumidity?: number | null;
};

export type AggregatedWeatherData = {
  xTick: number;
  minTemperature: number | null;
  maxTemperature: number | null;
  totalPrecipitation: number;
  weatherSymbol: string | null;
};
